import storageSession from "redux-persist/lib/storage/session";
const persistConfig = {
  key: "root",
  storage: storageSession,
};

export default persistConfig;
